export namespace TrustpilotUtils{
    export function GetReviewStarSvgPath(stars: number):string {
        
        let imageFolderAddress: string = '_content/LbRazor/dist/img/';
        let starSvgPath: string = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_5star-RGB.svg`;
       
        if (stars < 0.3)
        {
            starSvgPath = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_0star-RGB.svg`;
        }
        else if (stars >= 0.3 && stars < 0.8)
        {
            starSvgPath = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_1star-RGB.svg`;
        }
        else if (stars >= 0.8 && stars < 1.3)
        {
            starSvgPath = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_1star-RGB.svg`;
        }
        else if (stars >= 1.3 && stars < 1.8)
        {
            starSvgPath = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_1halfstar-RGB.svg`;
        }
        else if (stars >= 1.8 && stars < 2.3)
        {
            starSvgPath = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_2star-RGB.svg`;
        }
        else if (stars >= 2.3 && stars < 2.8)
        {
            starSvgPath = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_2halfstar-RGB.svg`;
        }
        else if (stars >= 2.8 && stars < 3.3)
        {
            starSvgPath = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_3star-RGB.svg`;
        }
        else if (stars >= 3.3 && stars < 3.8)
        {
            starSvgPath = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_3halfstar-RGB.svg`;
        }
        else if (stars >= 3.8 && stars < 4.3)
        {
            starSvgPath = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_4star-RGB.svg`;
        }
        else if (stars >= 4.3 && stars < 4.8)
        {
            starSvgPath = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_4halfstar-RGB.svg`;
        }
        else if (stars >= 4.8)
        {
            starSvgPath = `/${imageFolderAddress}trustPilot/Trustpilot_ratings_5star-RGB.svg`;
        }
        return starSvgPath;
    }
}